import styled from "styled-components";

export const Container = styled.div `
    position: fixed;
    inset: 0;
    background-image: linear-gradient(to bottom right, #404040bb, #303030aa);
    display: flex;
    align-items: end;
    justify-content: center;
    z-index: 99;
`

export const Content = styled.div `

    display: flex;
    flex-direction: column;
    width: ${props => props.full_page ? '100dvw' : '70dvw'};
    max-width: 1800px;
    height: ${props => props.full_page ? '100dvh' : '95dvh'};
    max-height: ${props => props.full_page ? '100dvh' : '95dvh'};
    background: #252525;
    padding: 20px 20px 50px 20px;
    border-radius: 5px;
    overflow-y: auto;
    box-shadow: 0 0 20px 5px #00000060;
    transition: all .5s ease;

    .header-person {
        display: flex;
        justify-content: space-between;
        position: sticky;
        top: -25px;
        padding: 20px 0;
        background-image: linear-gradient(to bottom, #252525,rgba(37, 37, 37, 0.66) , #25252500);
        z-index: 9;
    }

    .header-person a, .header-person button {
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        background: #30303099;
        border: 2px solid #aaa;
        border-radius: 50%;
        padding: 10px;
        transition: all .3s ease;
    }

    .header-person a:hover, .header-person button:hover {
        border-color: #fff;
        background: #000;
    }

    .hidden-component {
        display: none;
    }

    @media (max-width: 1000px) {
        width: ${props => props.full_page ? '100dvw' : '80dvw'};
    }

    @media (max-width: 800px) {
        width: ${props => props.full_page ? '100dvw' : '85dvw'};
    }

    @media (max-width: 800px) {
    
        .header-person a, .header-person button {
            padding: 7px;
        }

    }
`

export const PersonContainer = styled.div `
   
    .person {
        display: flex;
        flex-direction: column;
        height: max-content;
        border-radius: 5px;
        margin-top: -15px;
    }

    .person .section-info {
        display: flex;
        align-items: center;
        z-index: 2;
    }

    .person .section-info .image {
        min-width: 180px;
        max-width: 180px;
        min-height: 180px;
        max-height: 180px;
        margin-bottom: 10px;
        object-fit: cover;
        background: #252525;
        box-shadow: -1px 1px 10px 1px rgba(0, 0, 0, 0.1);
        border-radius: 50%;
        border: 1px solid #707070;
    }

    .div-about {
        display: flex;
        flex-direction: column;
        margin-left: 30px;
    }

    .name {
        margin: 0 0 5px 10px;
    }

    .name h1 {
        font-size: 20px;
    }
    
    .div-about .years-old {
        border-radius: 50px;
        color: #ccc;
        font-size: 14px;
        margin-bottom: 5px;
        white-space: nowrap;
    }

    .div-external-ids {
        margin-left: 0;
    }

    .swiper-external-ids {
        min-width: min-content;
        margin: 5px 0 0 -6px;
    }

    .swiper-slide:first-child {
        margin-left: 2px;
    }

    .swiper-external-ids a {
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        font-size: 1.2rem;
        margin: 3px 0;
        transition: all .3s ease;
    }

    .swiper-external-ids a {
        display: flex;
        align-items: center;
        background: #fff;
        padding: 7px 10px;
        border-radius: 50px;
        font-size: .9rem;
        font-weight: 700;
        color: #181818;
        transition: all .3s ease;
    }

    .swiper-external-ids a span {
        color: #181818;
        font-size: .9rem;
        margin-bottom: 0;
        margin-left: 5px;
    }

    .swiper-external-ids a:hover {
        background: #ccc;
    }

    .swiper-external-ids a i {
        font-size: 1.1rem;
    }

    .nav-person {
        position: relative;
        background-image: linear-gradient(to bottom, #252525 1%, #252525e6 80%, #25252500 95%);
        padding: 20px 0;
        margin-bottom: 10px;
    }

    .nav-person::before {
        position: absolute;
        content: '';
        right: 0;
        bottom: 15px;
        width: 30px;
        height: 80%;
        background-image: linear-gradient(to left, #252525, #25252500);
        z-index: 5;
    }

    .nav-person::after {
        position: absolute;
        content: '';
        left: 0;
        bottom: 20px;
        width: 100%;
        height: 2px;
        background: #404040;
    }

    .section-categoria-person-exibir {
        padding-bottom: 10px;
    }

    .section-categoria-person-exibir label {
        text-transform: uppercase;
        font-size: 1rem;
    }

    .section-categoria-person-exibir label a {
        font-weight: 700;
        color: #909090;
        padding: 10px 20px;
    }

    .section-categoria-person-exibir label a:hover {
        color: #ccc;
    }

    .label-categoria-person-exibir {
        color: #fff;
    }

    #link-exibir {
        position: relative;
        color: #fff;
        transition: all .3s ease;
    }

    #link-exibir:after {
        content: '';
        position: absolute;
        left: 0;
        bottom: 0;
        background: #fff;
        height: 2px;
        border-radius: 50px;
        width: 100%;
    }


    .span-carregando-exibir i {
        font-size: 20px;
    }

    @media (max-width: 800px) {

        .person .section-info .image {
            min-width: 160px;
            max-width: 160px;
            min-height: 160px;
            max-height: 160px;
        }

        .div-about {
            margin-left: 15px;
        }

    }

    @media (max-width: 600px) {
   
        .person {
            margin-top: 10px;
        }
        
        .person .section-info .image {
            min-width: 120px;
            max-width: 120px;
            min-height: 120px;
            max-height: 120px;
        }

        .name {
            margin: 0 0 5px 5px;
        }

        .name h1 {
            font-size: .9rem;
        }

        .div-about {
            margin-left: 10px;
        }

        .section-categoria-person-exibir label {
            font-size: .75rem;
        }
        
    }

    @media (max-width: 550px) {

        #facebook-external-id {
            display: none;
        }

        .swiper-external-ids a {
            padding: 6px 8px;
            font-size: .65rem;
        }
        
        .swiper-external-ids a span {
            font-size: .75rem;
        }

    }

    @media (max-width: 450px) {

        .person .section-info {
            padding: 0;
        }

        .person .section-info .image {
            min-width: 70px;
            max-width: 70px;
            min-height: 70px;
            max-height: 70px;
        }

    }

    @media (max-width: 400px) {

        .div-external-ids a {
            width: 25px;
            height: 25px;
        }

        .div-external-ids a span {
            display: none;
        }

        #facebook-external-id {
            display: block;
        }

    }
`